(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/behaviors/super/subscription.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/behaviors/super/subscription.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  svs.tur.start_subscription.behaviors.Subscription = Marionette.Behavior.extend({
    CONSTANTS: svs.tur.start_subscription.constants,
    options() {
      return {
        entryModel: new svs.tur.start_subscription.models.Entry(),
        prefix: ''
      };
    },
    initialize() {
      this.mergeOptions(this.options, ['entryModel', 'prefix']);
      this.listenTo(this, "".concat(this.prefix, "Subscription"), () => this.view.triggerMethod('setActiveContext', this));
      this.checkSwedbankPayTransaction();
    },
    triggerPrefixMethod(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      const argsLength = args && args.length;
      const prefixedEvent = "".concat(this.prefix, ":").concat(event);
      if (argsLength && args[argsLength - 1].triggerView) {
        this.view.triggerMethod(event, this, ...args);
      }
      this.view.triggerMethod(prefixedEvent, this, ...args);
      svs.tur.start_subscription.logger.debug('Subscription:triggerPrefixMethod - ', prefixedEvent, ...args);
    },
    verifyUser() {
      if (this.verifyLoggedIn()) {
        if (this.verifyNotBlocked()) {
          this.verifyEmail();
        }
      }
    },
    verifyNotBlocked() {
      if (svs.core.userSession.isBlocked()) {
        svs.accountservices.national_suspension_message.showNationalSuspensionPayMessage(() => {
          svs.events.publish('/subscription/activate/cancel');
        });
      } else if (svs.day_time_limit && svs.day_time_limit.data && svs.day_time_limit.data.dayTimeLimit && svs.day_time_limit.data.dayTimeLimit.dayTimeExpired) {
        svs && svs.accountservices && svs.accountservices.day_time_limit && svs.accountservices.day_time_limit.notices && svs.accountservices.day_time_limit.notices.pay();
      } else {
        return true;
      }
    },
    verifyLoggedIn() {
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        svs.utils.paramHandler.remove({
          key: 'pay'
        });
        return true;
      }
      svs.utils.paramHandler.set({
        key: 'pay',
        value: 'true'
      });

      let product = this.entryModel.get('subscriptionEntry') && this.entryModel.get('subscriptionEntry').wagers && this.entryModel.get('subscriptionEntry').wagers.length > 0 && this.entryModel.get('subscriptionEntry').wagers[0].bets && this.entryModel.get('subscriptionEntry').wagers[0].bets.length > 0 && this.entryModel.get('subscriptionEntry').wagers[0].bets[0] && this.entryModel.get('subscriptionEntry').wagers[0].bets[0].productId || this.entryModel.get('subscriptionOptions').product || 'unknown';
      product = svs.numbergames.productMapping.getProductName(product);
      const playerRegistrationExtraData = {
        amount: this.entryModel.get('subscriptionOptions').weeklyCost,
        product,
        weeks: '1',
        subscription: true,
        gift: false,
        branding: product.toLowerCase()
      };
      svs.components.customer_login.login({
        returnNewCustomer: true,
        extraParams: playerRegistrationExtraData
      });
    },
    verifyEmail() {
      svs.tur.start_subscription.radio.request('isEmailVerified', this, isEmailVerified => {
        if (isEmailVerified) {
          this.triggerPrefixMethod('isVerified');
        } else {
          this.view.triggerMethod('showVerifyEmail');
        }
      });
    },
    getEntryOrAnnouncement(success) {
      if (!success) {
        success = () => this.triggerPrefixMethod('showConfirmSubscription');
      }
      this.entryModel.getEntryOrAnnouncement({
        context: this,
        success
      });
    },
    postNewSubscription(success) {
      if (!success) {
        success = () => this.triggerPrefixMethod('subscriptionDefined');
      }
      this.entryModel.postNewSubscription({
        context: this,
        success
      });
    },
    getAutogiroInfo() {
      this.entryModel.getAutogiroInfo({
        context: this,
        success: () => this.view.triggerMethod('showAutogiroAgreement')
      });
    },
    getAutogiroInfoAndShowConfirm() {
      this.entryModel.getAutogiroInfo({
        context: this,
        success: () => this.triggerPrefixMethod('showConfirmSubscription')
      });
    },
    createDirectDebitPermission() {
      const bankInfo = {
        bankAccount: this.entryModel.get('bankAccountNumber'),
        bankName: this.entryModel.get('bankName')
      };
      svs.app.bankid.createDirectDebitPermission(bankInfo, response => this.createPaymentAccess(response), error => svs.tur.start_subscription.radio.trigger('handleError', {
        customError: 'autogiro',
        error
      }), this);
    },
    createPaymentAccess(response) {
      const autogiroInfo = {
        postToken: response.postToken,
        customerId: this.entryModel.get('customerId'),
        personNummer: this.entryModel.get('personalId'),
        accountReference: this.entryModel.get('bankAccountNumber')
      };
      svs.tur.start_subscription.radio.request('createPaymentAccess', autogiroInfo, this, () => this.view.triggerMethod('autogiroPaymentAccessCreated'));
    },
    payWithCard() {
      this.postNewSubscription(() => this.triggerPrefixMethod('makeCardPayment'));
    },
    makeCardPayment() {
      svs.tur.start_subscription.utils.updateQuerystringWithParamAndValue('swpsubid', this.entryModel.get('newSubId'));
      const swpReturnUrl = location.href;
      svs.tur.start_subscription.radio.request('makeSwedbankPayCardPayment', this.entryModel.get('newSubId'), this.entryModel.get('amount'), swpReturnUrl, this);
    },
    pollNewSubscription(success) {
      svs.tur.start_subscription.radio.request('pollNewSubscription', this.entryModel.get('newSubId'), this, success, () => {
        window.location.href = "".concat(svs.core.urlMapping.get('myGamingsSubscriptions'), "?pollError=1");
      });
    },
    showBankcardPaymenttype(model, context) {
      svs.components.Modal.show(svs.tur.start_subscription.views.BankcardPayment, {
        model,
        context
      }, {
        title: 'Betala prenumeration',
        contentClass: svs.core.detect.formfactor.mobile() ? 'bg-white' : '',
        doubleWidth: true,
        rightButton: {
          visible: false
        },
        leftButton: {
          text: 'Avbryt',
          visible: true,
          callback: () => {
            const subscriptionId = this.entryModel.get('newSubId');
            if (subscriptionId) {
              svs.tur.start_subscription.radio.request('cancelSubscription', subscriptionId, this, () => {});
            }

            const swpCheckout = svs.tur.start_subscription.radio.request('getSwedbankPayCheckoutObject', this);
            if (typeof (swpCheckout === null || swpCheckout === void 0 ? void 0 : swpCheckout.cleanUpSwedbankPayTransaction) === 'function') {
              this.triggerPrefixMethod('cancelButtonFirstPayBankcardSubscription');
              this.entryModel.set('paymentCancelled', true);
              swpCheckout.cleanUpSwedbankPayTransaction();
            } else {
              this.triggerPrefixMethod('cancelButtonBeforeFirstPayBankcardSubscription');
            }

            const cancelUrl = this.entryModel.get('cancelUrl');
            svs.components.Modal.hide();
            if (cancelUrl) {
              svs.components.loader.show();
              svs.utils.url.navigate(cancelUrl);
            }
          }
        }
      });
      if (model && model.isComingBack) {
        $('.js-modal-container').hide();
      } else {
        svs.components.Modal && svs.components.Modal.currentView() && svs.components.Modal.currentView().trigger('modalContentResize');
        for (let i = 1; i < 11; i++) {
          setTimeout(() => {
            svs.components.Modal && svs.components.Modal.currentView() && svs.components.Modal.currentView().trigger('modalContentResize');
          }, i * 1000);
        }
      }
    },
    checkSwedbankPayTransaction() {
      const subId = svs.tur.start_subscription.utils.getUrlParam('swpsubid');
      const activating = Boolean(svs.tur.start_subscription.utils.getUrlParam('act') && svs.tur.start_subscription.utils.getUrlParam('act').toLowerCase() === 'true');
      if (subId) {
        svs.tur.start_subscription.utils.clearUrlParam('pay');
        svs.tur.start_subscription.utils.clearUrlParam('betala');
        this.showBankcardPaymenttype({
          hide: false,
          isComingBack: true,
          subId
        }, this);
        svs.tur.start_subscription.radio.request('makeSwedbankPayCardPayment', subId, undefined, undefined, this, activating);
      }
    }
  });
})(Backbone, _, svs);

 })(window);